
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lausnir/fyrirtaeki",
      function () {
        return require("private-next-pages/lausnir/fyrirtaeki.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lausnir/fyrirtaeki"])
      });
    }
  